import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  ViewChild,
} from '@angular/core';
import { Chart, ChartConfiguration } from 'chart.js';
import { MigrationStats } from '../../../service/coursera-dashboard-stats.model';

@Component({
  selector: 'app-coursera-migration-chart',
  templateUrl: './coursera-migration-chart.component.html',
  styleUrls: ['./coursera-migration-chart.component.css'],
})
export class CourseraMigrationChartComponent implements OnChanges {
  @Input() data: MigrationStats[] = [];
  @ViewChild('migrationChart') chartRef!: ElementRef;

  chart!: Chart;

  ngOnChanges(): void {
    if (!this.data || this.data.length === 0) return;

    // 🔥 attendre que le DOM soit prêt
    setTimeout(() => {
      this.createChart();
    });
  }

  createChart() {
    if (!this.chartRef?.nativeElement) return;

    const ctx = this.chartRef.nativeElement.getContext('2d');

    const labels = this.data.map((d) => d.statut);
    const values = this.data.map((d) => d.total);

    if (this.chart) {
      this.chart.destroy();
    }

    const config: ChartConfiguration = {
      type: 'pie',
      data: {
        labels: labels,
        datasets: [
          {
            data: values,
          },
        ],
      },
      options: {
        responsive: true,
      },
    };

    this.chart = new Chart(ctx, config);
  }
}
